import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=6076b106&scoped=true"
import script from "./user-detail.vue?vue&type=script&lang=js"
export * from "./user-detail.vue?vue&type=script&lang=js"
import style0 from "./user-detail.vue?vue&type=style&index=0&id=6076b106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6076b106",
  null
  
)

export default component.exports